document.addEventListener('turbolinks:load', function () {
  $('.content_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.content_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.content_slidedown_btn').fadeIn(0));
  });

  $('.content_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.content_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.content_slideup_btn').fadeIn(0));
  });

  // ------------------------------------------------------------------------------------------------
  // コンテンツ分析
  // ------------------------------------------------------------------------------------------------
  function contents_update_url() {
    const content_id = $('#content_selects option:selected').val();
    const gf = $('#content_graph_pattern_select_input').val();
    // const device = $('.content_device_select').data('device');
    const start_day = $('#content_report_start_day').val();
    const end_day = $('#content_report_end_day').val();

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (content_id !== 'none' && content_id !== null && content_id !== undefined) {
      params.set('content_id', content_id);
    } else {
      params.delete('content_id');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    // if (device == "0" || device == "1" || device == "2") {
    //   params.set('device', device);
    // } else {
    //   params.delete('device');
    // }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {  // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // コンテンツ,コンテンツメニューの選択
  // #################################################################
  $('#content_selects').on('change', function () {
    contents_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.content_graph_pattern_select_day, .content_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#content_graph_pattern_select_input').val(gf_value);
    contents_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#content_report_start_day, #content_report_end_day').on('change', function () {
    contents_update_url();
  });

  // #################################################################
  // コンテンツのログデータのみの削除
  // #################################################################
  $('.delete_content_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const content_id = $('#content_selects option:selected').val();

    $.ajax({
      url: '/content_report/delete_content_log',
      type: 'POST',
      data: {
        content_id: content_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // コンテンツのログデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_content_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const content_id = $('#content_selects option:selected').val();

    $.ajax({
      url: '/content_report/delete_content_log_and_related_data',
      type: 'POST',
      data: {
        content_id: content_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.href = '/content_report/index';
      }
    });
  });

  // #################################################################
  // コンテンツのレポートのcsv出力
  // #################################################################
  $('#download_content_csv').on('click', function () {
    const content_id = $('#content_selects option:selected').val();
    const month = $('#ua_content_month_selects option:selected').val();

    let href = '/download_content_csv';

    href += `?content_id=${content_id}`;
    href += `&m=${month}`;
    location.href = href;
  });

  // ------------------------------------------------------------------------------------------------
  // コンテンツ管理
  // ------------------------------------------------------------------------------------------------
  // #################################################################
  // コンテンツ管理の新規作成
  // #################################################################
  $('#contents_create').on('click', function () {
    const name = $('.contents_input').val();

    if (!name) {
      alert('コンテンツ名を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/create',
      type: 'POST',
      data: {
        name: name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.href = `/content/index?contents_id=${data.content.id}`;
      }
    });
  });

  // #################################################################
  // コンテンツ管理の切り替え
  // #################################################################
  $('.contents_select_box').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    if (contents_id == 'new') {
      $('.contents_set_wrapper_display').css('display', 'block');
      $('.contents_img_upload_wrapper').css('display', 'none');
      $('.contents_mode_setting_wrapper').css('display', 'none');
      $('.contents_display_type_setting_wrapper').css('display', 'none');
      $('.contents_display_time_ms_setting_wrapper').css('display', 'none');
      $('.contents_html_set_wrapper').css('display', 'none');
      $('.content_html_preview_wrapper').css('display', 'none');
      $('.contents_delete_btn_setting_wrapper').css('display', 'none');
      $('.contents_delete_btn_color_setting_wrapper').css('display', 'none');
      $('.contents_next_display_setting_wrapper').css('display', 'none');
      $('.contents_jump_url_setting_wrapper').css('display', 'none');
      $('.contents_popup_size_setting_wrapper').css('display', 'none');
      $('.popup_preview_position_setting_wrapper').css('display', 'none');
      $('.content_report_jump_btn').css('display', 'none');
      $('.content_delete_setting_wrapper').css('display', 'none');

    } else {
      location.href = `/content/index?contents_id=${contents_id}`;
    }
  });

  // #################################################################
  // コンテンツモードの切り替え
  // #################################################################
  $('.contents_mode_select_box').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    // let is_mode = $('.contents_mode_select_box option:selected').val();
    let is_mode = $('.contents_mode_select_box:checked').val();

    $.ajax({
      url: '/change_content_mode',
      type: 'POST',
      data: {
        contents_id: contents_id,
        is_mode: is_mode
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // コンテンツ表示方法の切り替え
  // #################################################################
  $('.contents_display_type_select_box').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    // let display_type = $('.contents_display_type_select_box option:selected').val();
    let display_type = $('.contents_display_type_select_box:checked').val();
    $.ajax({
      url: '/change_content_display_type',
      type: 'POST',
      data: {
        contents_id: contents_id,
        display_type: display_type
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // コンテンツ名の編集
  // #################################################################
  $('#contents_name_edit_btn').on('click', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let name = $('.contents_name_val').val();

    if (!name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_content_name',
      type: 'POST',
      data: {
        contents_id: contents_id,
        name: name
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 画像登録
  // #################################################################
  $('#contents_img_upload_btn').on('click', function() {
    let contents_id = $('.contents_select_box option:selected').val();
    let file_data = $('.content_img_upload').prop('files')[0];
    if (!file_data) {
      alert('画像を選択してください。');
      return;
    }
    let form_data = new FormData();
    form_data.append('content_img_upload', file_data);
    form_data.append('contents_id', contents_id); // contents_idをFormDataに追加

    $.ajax({
      url: '/upload_content_img',
      type: 'POST',
      data: form_data,
      processData: false,
      contentType: false,
      success: function(response) {
        location.reload();
      },
      error: function(response) {
        alert('画像のアップロードに失敗しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // 画像削除
  // #################################################################
  $('#contents_img_delete_btn').on('click', function() {
    let contents_id = $('.contents_select_box option:selected').val();

    $.ajax({
      url: '/delete_content_img',
      type: 'POST',
      data: {
        contents_id: contents_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // htmlのコンテンツの登録
  // #################################################################
  $('#contents_html_submit_btn').on('click', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let html = $('#contents_html').val();
    $.ajax({
      url: '/save_content_html',
      type: 'POST',
      data: {
        contents_id: contents_id,
        html: html
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // htmlのコンテンツサイズの登録
  // #################################################################
  $('#popup_html_size_btn').on('click', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let width = $('.popup_html_width_val').val();
    let height = $('.popup_html_height_val').val();

    $.ajax({
      url: '/save_content_html_size',
      type: 'POST',
      data: {
        contents_id: contents_id,
        width: width,
        height: height
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // htmlのコンテンツの表示/非表示
  // #################################################################
  $(".content_html_delete_btn").on("click", function(){
    $(".content_html_delete_btn").css("display","none");
    $(".content_html_display_btn").css("display","flex");
    $(".content_html_preview").css("display","none");
  });
  $(".content_html_display_btn").on("click", function(){
    $(".content_html_delete_btn").css("display","flex");
    $(".content_html_display_btn").css("display","none");
    $(".content_html_preview").css("display","block");
  });

  // #################################################################
  // HTMLの削除ボタンの位置の切り替え
  // #################################################################
  $('.contents_delete_btn_select_box').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let delete_btn_position = $('.contents_delete_btn_select_box option:selected').val();
    $.ajax({
      url: '/change_delete_btn_position',
      type: 'POST',
      data: {
        contents_id: contents_id,
        delete_btn_position: delete_btn_position
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップ画像のサイズ登録
  // #################################################################
  $('#contents_popup_size_btn').on('click', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let contents_popup_width_val = $('.contents_popup_width_val').val();
    let contents_popup_height_val = $('.contents_popup_height_val').val();
    let contents_img_border_color_val = $('.contents_img_border_color_val').val();

    if (!$('.contents_popup_border_flag').is(':checked')) {
      contents_img_border_color_val = "";
    }

    if (!contents_popup_width_val || !contents_popup_height_val) {
      alert('画像サイズを設定してください。');
      return;
    }

    $.ajax({
      url: '/save_popup_size',
      type: 'POST',
      data: {
        contents_id: contents_id,
        img_width: contents_popup_width_val,
        img_height: contents_popup_height_val,
        img_border_color: contents_img_border_color_val
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップ画像のサイズ自動調整
  // #################################################################
  // 幅の変更を監視
  $('.contents_popup_width_val').on('input', function() {
    let widthStr = $(this).val(); // 現在の幅の値（文字列）
    let width = parseInt(widthStr.replace('px', ''), 10); // 'px'を削除して数値に変換
    let aspectWidth = $(this).data('img_width'); // アスペクト比の幅
    let aspectHeight = $('.contents_popup_height_val').data('img_height'); // アスペクト比の高さ
    let newHeight = (width * aspectHeight) / aspectWidth; // 新しい高さを計算
    $('.contents_popup_height_val').val(`${newHeight.toFixed()}px`); // 小数点以下を切り捨てて設定
  });

  // 高さの変更を監視
  $('.contents_popup_height_val').on('input', function() {
    let heightStr = $(this).val(); // 現在の高さの値（文字列）
    let height = parseInt(heightStr.replace('px', ''), 10); // 'px'を削除して数値に変換
    let aspectWidth = $('.contents_popup_width_val').data('img_width'); // アスペクト比の幅
    let aspectHeight = $(this).data('img_height'); // アスペクト比の高さ
    let newWidth = (height * aspectWidth) / aspectHeight; // 新しい幅を計算
    $('.contents_popup_width_val').val(`${newWidth.toFixed()}px`); // 小数点以下を切り捨てて設定
  });

  // #################################################################
  // 削除ボタンの色の有無
  // #################################################################
  $('.contents_popup_is_bg_color_val').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let is_delete_btn_bg_color = $('.contents_popup_is_bg_color_val').val();

    if (is_delete_btn_bg_color == "0" || !is_delete_btn_bg_color) {
      is_delete_btn_bg_color = 1;
    } else {
      is_delete_btn_bg_color = 0;
    }

    $.ajax({
      url: '/save_is_delete_btn_color',
      type: 'POST',
      data: {
        contents_id: contents_id,
        is_delete_btn_bg_color: is_delete_btn_bg_color,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 削除ボタンの色
  // #################################################################
  $('.contents_popup_bg_color_val, .contents_popup_text_color_val').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let contents_popup_bg_color_val = $('.contents_popup_bg_color_val').val();
    let contents_popup_text_color_val = $('.contents_popup_text_color_val').val();

    if (!contents_popup_bg_color_val || !contents_popup_text_color_val) {
      alert('色を選択して下さい。');
      return;
    }

    $.ajax({
      url: '/save_delete_btn_color',
      type: 'POST',
      data: {
        contents_id: contents_id,
        bg_color: contents_popup_bg_color_val,
        text_color: contents_popup_text_color_val,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 再表示までの期間
  // #################################################################
  $('.contents_next_display_select_box').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let redisplay = $('.contents_next_display_select_box option:selected').val();
    $.ajax({
      url: '/change_redisplay',
      type: 'POST',
      data: {
        contents_id: contents_id,
        redisplay: redisplay
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // 遷移先URLの登録
  // #################################################################
  $('#contents_popup_url_btn').on('click', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let url = $('.contents_popup_url_val').val();

    if (!url) {
      alert('URLを記入して下さい。');
      return;
    }

    $.ajax({
      url: '/save_jump_to_url',
      type: 'POST',
      data: {
        contents_id: contents_id,
        url: url
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの表示位置設定
  // #################################################################
  $('.contents_display_position_btn').on('click', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let contents_display_position = $(this).data("cdp");
    
    $.ajax({
      url: '/content/save_popup_display_position',
      type: 'POST',
      data: {
        contents_id: contents_id,
        contents_display_position: contents_display_position
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの表示位置調整設定
  // #################################################################
  $('#contents_top_offset, #contents_bottom_offset, #contents_left_offset, #contents_right_offset').on('keypress blur', function (event) {
    // エンターキーが押されたかどうかをチェックし、エンターキーが押された場合にのみ処理を進めます
    if (event.type === 'keypress' && event.which !== 13) {
      return;
    }
    let contents_id = $('.contents_select_box option:selected').val();
    let contents_position = $(this).data("position");
    let contents_offset = $(this).val();

    if (!contents_offset) {
      alert("入力して下さい。");
      return;
    }
    $.ajax({
      url: '/content/save_popup_contents_offset',
      type: 'POST',
      data: {
        contents_id: contents_id,
        contents_position: contents_position,
        contents_offset: contents_offset
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの背景の有無
  // #################################################################
  $('.popup_background_select_box').on('change', function () {
    let contents_id = $('.contents_select_box option:selected').val();
    let is_background = $('.popup_background_select_box option:selected').val();
    $.ajax({
      url: '/content/save_popup_is_background',
      type: 'POST',
      data: {
        contents_id: contents_id,
        is_background: is_background
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの背景色設定
  // #################################################################
  $('#popup_background_color').on('change', function (event) {
    let contents_id = $('.contents_select_box option:selected').val();
    let background_color = $('#popup_background_color').val();
    $.ajax({
      url: '/content/save_popup_background_color',
      type: 'POST',
      data: {
        contents_id: contents_id,
        background_color: background_color
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // ポップアップの背景の透過設定
  // #################################################################
  $('.popup_background_opacity_select_box').on('change', function (event) {
    let contents_id = $('.contents_select_box option:selected').val();
    let background_opacity = $('.popup_background_opacity_select_box option:selected').val();
    $.ajax({
      url: '/content/save_popup_background_opacity',
      type: 'POST',
      data: {
        contents_id: contents_id,
        background_opacity: background_opacity
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // コンテンツ管理削除
  // #################################################################
  $('#content_delete_btn').on('click', function () {
    let contents_id = $('.contents_select_box option:selected').val();

    if (!confirm('完全に削除され復元することはできません。本当に削除しますか？')) {
      return;
    }

    $.ajax({
      url: '/content/delete_contents',
      type: 'POST',
      data: {
        contents_id: contents_id,
      },
      dataType: 'json',
    }).done(function (data) {
      alert('コンテンツを削除しました。');
      location.href = `/contents_list/index`;
    });
  });
});
